<template>
    <div>
        <v-row>
            <img class="stage-image-position" :src="`/${stage_key}.png`" />
        </v-row>
        <v-row>
            <v-spacer></v-spacer>
            <span class="display-1 font-weight-medium">{{ stage.name && stage.name.toUpperCase() }}</span>
            <v-spacer></v-spacer>
        </v-row>
        <v-row>
            <v-col class="col-1 col-md-3"></v-col>
            <v-col class="col-10 col-md-6">
                <div class="start-content font-weight-medium" v-html="stage.start_text">
                </div>
            </v-col>
            <v-col class="col-1 col-md-3"></v-col>
        </v-row>
        <v-row>
            <span v-on:click="startStage()" class="start-link body-1">START</span>
        </v-row>
    </div>
</template>
<script>
// import { stages } from '../db/testdb.js';
// import Client from '../client.js';

export default {
    props: {
        stage_key: String,
        application_id: [String, Number]
    },
    data: function() {
        return {
            // stage: {name: ''},
            consent: false
        }
    },
    mounted: async function() {
        // this.$store.dispatch('stage/fetchStages');
        // let client = Client();
        // let res = await client.get(`/stages/${this.stage_key}`);

        // this.stage = res.data;
    },
    // computed: {
    //     isTrue() {
    //         return [v => v === true];
    //     }
    // },
    computed: {
        stage() {
            const stages = this.$store.getters['stage/stages'];
            if(stages.length > 0) {
                return stages.find(s => s.key === this.stage_key);
            } else {
                return {};
            }
        }
    },
    methods: {
        startStage: function() {
            this.$router.push({
                name: "stage.question",
                params: {
                    sort: 1,
                    stage_key: this.stage_key,
                    application_id: this.application_id
                }
            });
            return;
        }
    }
}
</script>
<style lang="scss">
.stage-image-position {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 40px;
}

.title-wrapper {
    text-align: center;
    width: 100%;
    color: $go-dark-grey;
    margin-bottom: 10px;
}

.start-content {
    margin-bottom: 40px;
    font-family: $secondary-font;
    line-height: 1.75rem;
    font-size: 1rem;
}

.start-content > * {
    // font-family: $secondary-font !important;
    color: $go-text-grey;
}

.start-content > ul {
    margin-left: 40px;
}

.start-link {
    text-decoration: none;
    display: block;
    margin-left: auto;
    margin-right: auto;
    border: 1px solid $go-dark-grey;
    border-radius: 3px;
    background-color: $go-dark-grey;
    color: white;
    padding: 12px 25px 12px 25px;
    font-family: $secondary-font !important;
}

.start-link:hover {
    color: $go-dark-grey;
    cursor: pointer;
    background-color: white;
}
</style>
